import { doc, DocumentData, getDoc } from 'firebase/firestore';
import { create } from 'zustand';

import { db } from './config';

// Define store state interface
interface UserStoreState {
  currentUser: DocumentData | null;
  isLoading: boolean;
  fetchUserInfo: (uid: string | null) => Promise<void>;
}

export const useUserStore = create<UserStoreState>((set) => ({
  currentUser: null,
  isLoading: true,
  fetchUserInfo: async (uid) => {
    if (!uid) return set({ currentUser: null, isLoading: false });

    try {
      const docRef = doc(db, 'users', uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        set({ currentUser: docSnap.data(), isLoading: false });
      } else {
        set({ currentUser: null, isLoading: false });
      }
    } catch (err) {
      return set({ currentUser: null, isLoading: false });
    }
  },
}));
